import { Collapse } from "@mui/material";
import React from "react";

function IngredientCollapse({
  ingredient,
  onIngredientClick,
  language,
  mobile,
  collapsedSize = window.innerHeight,
  ingredientPreview,
}) {
  const { id, title, preview, ingredient: ingredientData } = ingredient;

  const collapsedMinSize = 140;
  const innerCollapseMinSize = ingredientPreview
    ? collapsedSize / ingredientPreview.length < collapsedMinSize
      ? collapsedMinSize
      : collapsedSize / ingredientPreview.length
    : collapsedSize;

  const buttonClass = `custom-button-link white ingredient-title-button${
    mobile ? "-mobile" : ""
  }`;

  return (
    <Collapse key={id} in={false} collapsedSize={innerCollapseMinSize}>
      <div
        id={id}
        className="ingredient-content-mobile"
        style={{ height: innerCollapseMinSize }}
      >
        <div className="ingredient-title">
          <button className={buttonClass} onClick={onIngredientClick}>
            {title[language]}
          </button>
        </div>
        <img
          className="ingredient-preview-mobile"
          style={{ height: window.innerHeight }}
          src={preview}
          alt={ingredientData}
        />
      </div>
    </Collapse>
  );
}

export default IngredientCollapse;
